import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BottomNav from "../../../../containers/BottomNav";
import GamesSearchModal from "../../../components/GamesSearchModal";
import { altGaming } from "../../../../lib/data/altGaming.data";

const ALTGaming = () => {
  const navigate = useNavigate();
  const categoriesTab = [
    { name: "Jili Gaming", key: "jiliGaming" },
    { name: "Mac88 Gaming", key: "mac88Gaming" },
    { name: "Mac88 Virtual Gaming", key: "mac88gamingvirtual" },
    // { name: "Chicken Games", key: "chickenGames" },
    // { name: "Voltent", key: "voltentGaming" },
    // { name: "ICONIC21", key: "iconic21Gaming" },
    // { name: "Turbo Games", key: "turboGaming" },
    // { name: "PGSoft", key: "pgsoftGaming" },
    // { name: "Booming Games", key: "boomingGames" },
    // { name: "Bet Games", key: "betGames" },
    // { name: "Play'n Go", key: "playnGoGaming" },
    // { name: "Playtech Live", key: "playtechliveGaming" },
    // { name: "Smartsoft Gaming", key: "smartsoftGaming" },
  ];
  const [activeCategory, setActiveCategory] = useState("jiliGaming");

  // **Get Games for Active Category**
  const filteredGames = altGaming[activeCategory]
    ? Object.values(altGaming[activeCategory])
    : [];

  console.log("Active Category:", activeCategory);
  console.log("Filtered Games:", filteredGames);

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="prvdr-game-page">
          <div className="games-heading">
            <h3>ALT Gaming</h3>
            <div className="d-none d-lg-block">
              <GamesSearchModal />
            </div>
          </div>

          {/* CATEGORY TABS */}
          <ul className="tabs">
            {categoriesTab.map((tab, index) => (
              <li
                key={index}
                onClick={() => {
                  if (tab?.redirectUrl) {
                    navigate(tab?.redirectUrl);
                  } else {
                    setActiveCategory(tab.key);
                  }
                }}
              >
                <a
                  href="#"
                  className={activeCategory === tab.key ? "active" : ""}
                >
                  {tab.name}
                </a>
              </li>
            ))}
          </ul>

          {/* GAMES LIST */}
          <ul className="gamelisting">
            {filteredGames.length > 0 ? (
              filteredGames.map((game, idx) => (
                <li key={"casinogame" + idx}>
                  <a href={game.redirectUrl}>
                    <img src={game.imgUrl} alt={game.alt} />
                    <div className="providerName">{game.providerName}</div>
                    <div className="GameName">{game.name}</div>
                  </a>
                </li>
              ))
            ) : (
              <p>No games available for this category.</p>
            )}
          </ul>
        </div>
      </main>

      <BottomNav />
    </>
  );
};

export default ALTGaming;
